/** Drawing-specific model controls; QuantisAI uses files already held in the system. */
import type { SIModelPicker } from './siModels';

/** Takeoff offers the Claude models through the platform's own menu control. */
export type TakeoffModelPicker = { value: string; options: readonly { id: string; label: string }[]; onChange: (model: string) => void };

export function SIComposerTrailingControls({ running, takeoffModel }: { running: boolean; model?: SIModelPicker; takeoffModel?: TakeoffModelPicker }) {
  if (takeoffModel) return <select aria-label="Takeoff model" title="Drawing takeoff model" disabled={running} value={takeoffModel.value}
    onChange={event => takeoffModel.onChange(event.target.value)}
    className="h-8 max-w-[11rem] shrink-0 rounded-lg bg-transparent px-2 text-xs text-muted-foreground hover:bg-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50">
    {takeoffModel.options.map(option => <option key={option.id} value={option.id}>{option.label}</option>)}
  </select>;
  return null;
}
